<div class="map-container">
  <div id="map-content" class="map-style" [class.note-mode]="mode == 'view' || mode == 'add'">
    <div id="overlay" class="overlay-map display-none"></div>
  </div>
  <div [class.d-none]="mode === 'add' || mode  === 'view'">
    <app-crop-health-map-header
      [loading]="loading"
      [fullScreenMode]="fullScreenMode"
      [cropHealthData]="cropHealthData"
      [selectedMapType]="selectedMapType"
      [notes]="notes"
      [selectedDay]="selectedDay"
      (clickFullScreenEvent)="onClickFullScreen()"
      (notesViewChangedEvent)="onNotesViewChanged($event)" />
    @if (cropHealthData?.mapList?.length > 0) {
      <app-crop-health-map-calendar
        [cropHealthData]="cropHealthData"
        [fullScreenMode]="fullScreenMode"
        [selectedMapType]="selectedMapType"
        (dateSelectionPlaceEvent)="onDateSelectionPlace($event)"
        (selectDateEvent)="selectDateEvent.emit($event)"
        (loadMore)="loadMoreEvent.emit($event)" />

      <app-crop-health-map-footer
        [loading]="loading"
        [selectedMapType]="selectedMapType"
        (mapSelectionPlaceEvent)="onMapSelectionPlace($event)" />
    }

    <app-crop-health-map-controls (onZoomClick)="onZoomClick($event)" />
  </div>
  @if (mapOverlayMessage && mode !== 'view') {
    <app-crop-health-map-message-overlay
      (seeProblameticSpot)="seeProblematicSpotEvent.emit()" />
  }
</div>
